import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import './css/style.less'
import * as util from '@/libs/util';
import {isNotNull, isNull, msg, msgs} from '@/libs/util';
import LyTab from 'ly-tab';
//import * as echarts from 'echarts'
//Vue.prototype.$echarts = echarts  // 挂载到Vue实例上，方便全局使用


Vue.use(ElementUI);
Vue.use(LyTab);
Vue.config.productionTip = false
Vue.prototype.$util = util;
Vue.prototype.$isNull = isNull;
Vue.prototype.$isNotNull = isNotNull;
Vue.prototype.$msg = msg;
Vue.prototype.$msgs = msgs;
Vue.prototype.$globalData = {
    timmer1: null,  // 设备状态监控 /device/moniter
    timmer2: null,  // 大屏 /moniter
    timmer3: null,  // 施工实时监控 /working/list - 左侧数据表
    timmer4: null,  // 施工实时监控 /working/list - 右侧详情数据
    timmer5: null,  // 施工实时监控 /working/list - 右侧实时数据
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
